import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getCitiesByState = async ({ queryKey }) => {
	const [, state] = queryKey;

	const url = `/cidade/cidadeByEstado?sigla_estado=${state}`;
	const response = await api.get(url);
	return response.data;
};

export const useCityByStateList = state => {
	return useQuery(['city-list', state], getCitiesByState, {
		enabled: !!state,
		refetchOnWindowFocus: false,
	});
};
